/* ============================================================================
   App messages.

   Every message in the app goes through Utils.toast(type, message), which
   calls showToast() here. It only dispatches an event; <PageAlert/> renders
   it as a floating liquid glass toast at the top of the viewport. Call sites
   are unchanged.
   ========================================================================== */
export const ALERT_EVENT = "app:alert";

export const showToast = (type, message) => {
  if (!message) return;
  window.dispatchEvent(
    new CustomEvent(ALERT_EVENT, { detail: { type: type || "info", message } })
  );
};

export default showToast;
